var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSelected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58.794,
    height: 93.412,
    viewBox: "0 0 15.556 24.715",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-85.722 -136.32)",
    fontSize: 37.333,
    fontFamily: "Ok",
    "white-space": "pre"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      InkscapeFontSpecification: "Ok"
    },
    cx: 92.465,
    cy: 159.276,
    rx: 5.265,
    ry: 1.72,
    fill: "#2b9cfb",
    fillOpacity: 0.667,
    stroke: "#2b9cfb",
    strokeWidth: 0.078,
    strokeOpacity: 0.671
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      InkscapeFontSpecification: "Ok"
    },
    cx: 92.544,
    cy: 159.186,
    rx: 1.031,
    ry: 0.353,
    fill: "#2b9cfb",
    fillOpacity: 0.667,
    strokeWidth: 0.048
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.567 147.464l1.127-1.303-4.411-8.945-2.561-.896zm.418 11.584l1.012.354.92-10.026 7.361-7.612-2.561-.896-6.624 7.646z",
    style: {
      InkscapeFontSpecification: "Okeanys"
    },
    fill: "#0c0d0d",
    fillOpacity: 1,
    stroke: "#353838",
    strokeWidth: 0,
    strokeOpacity: 1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelected);
export default __webpack_public_path__ + "static/media/selected.c3c641f80c8c6c2acb638dbb791e1401.svg";
export { ForwardRef as ReactComponent };